var PrescriptionType = /* @__PURE__ */ ((PrescriptionType2) => {
  PrescriptionType2["EXISTING_CUSTOMER"] = "ExistingCustomer";
  PrescriptionType2["NEW_PRESCRIPTION"] = "NewPrescription";
  PrescriptionType2["PRESCRIPTION_FILE"] = "PrescriptionFile";
  PrescriptionType2["EMAIL_PRESCRIPTION"] = "EmailPrescription";
  PrescriptionType2["OCR_PRESCRIPTION"] = "OCRPrescription";
  PrescriptionType2["PRESCRIPTION_WITH_MANUAL_XOR_FILE_PUPILLARY_DISTANCE"] = "PrescriptionWithManualXORFilePupillaryDistance";
  return PrescriptionType2;
})(PrescriptionType || {});
export {
  PrescriptionType
};
//# sourceMappingURL=types.js.map
